<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <v-overlay :value="visible" :absolute="false" opacity="1" class="overlay-mobile">
                <div class="main-container-mobile">
                    <!-- <img src="@/assets/img/top-left-bg.png" alt="Background" class="background-image-mobile-topleft" />
                    <img src="@/assets/img/top-right-bg.png" alt="Background"
                        class="background-image-mobile-topright" />
                    <img src="@/assets/img/bot-left-bg.png" alt="Background" class="background-image-mobile-botleft" />
                    <img src="@/assets/img/bot-right-bg.png" alt="Background"
                        class="background-image-mobile-botright" /> -->
                    <!-- <img src="@/assets/img/age-confirmation-bg.jpg" alt="Background" class="background-image-mobile" /> -->
                    <!-- <img src="@/assets/img/jameson-logo-age-confirm.jpg" alt="Background" class="background-image-mobile" /> -->
                    <div class="foreground-container-mobile">
                        <div class="first-block-mobile">
                            <img src="@/assets/img/ararat-age-confirm-logo.png" alt=""
                                class="jameson-logo-age-confirm-mobile" />
                            <h4 class="title-text-mobile">Введите дату
                                <pre>рождения</pre>
                            </h4>
                            <div class="date-input-container-mobile">
                                <input type="text" maxlength="2" placeholder="дд" @input="validateDay" v-model="day"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="2" placeholder="мм" @input="validateMonth" v-model="month"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="4" placeholder="гггг" @input="validateYear" v-model="year"
                                    class="date-input-mobile" />
                            </div>
                            <button @click="confirmRegistration"
                                class="btn-confirm-mobile mt-6 mb-2">Подтверждаю</button>
                        </div>
                        <!-- <div class="second-block-mobile">
                            <img src="@/assets/img/ararat-age-confirm-mobile-img-bottle.png" alt=""
                                class="jameson-age-confirm-mobile" />

                        </div> -->
                    </div>
                </div>
            </v-overlay>
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <v-overlay :value="visible" :absolute="false" opacity="1">
                <div class="main-container">
                    <img src="@/assets/img/ararat-reg-bg.jpg" alt="Background" class="background-image" />
                    <div class="foreground-container">
                        <div class="first-block">
                            <img src="@/assets/img/ararat-age-confirm-logo.svg" alt=""
                                class="jameson-logo-age-confirm" />
                            <h4 class="title-text">Введите дату рождения</h4>
                            <div class="date-input-container">
                                <input type="text" maxlength="2" placeholder="дд" @input="validateDay" v-model="day"
                                    class="date-input" />
                                <input type="text" maxlength="2" placeholder="мм" @input="validateMonth" v-model="month"
                                    class="date-input" />
                                <input type="text" maxlength="4" placeholder="гггг" @input="validateYear" v-model="year"
                                    class="date-input" />
                            </div>
                            <button @click="confirmRegistration" class="btn-confirm mt-10 mb-10">Подтверждаю</button>
                        </div>
                        <!-- <div class="second-block">
                            <img src="@/assets/img/age-confirm-main-img.jpg" alt="" class="jameson-age-confirm" />

                        </div> -->
                    </div>
                </div>
            </v-overlay>
        </div>
        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>
</template>

<style scoped>
/* ----------------------------------------Desktop main styles */
::v-deep .v-overlay__scrim {
    opacity: 1;
    /* background-color: #007749 !important;
    border-color: #007749 !important; */
    background-image: url('../assets/img/ararat-reg-bg.jpg');
    background-size: cover;
    background-position: center;
}

.main-container {
    position: relative;
    /* Родительский контейнер для абсолютного позиционирования */
    height: 100vh;
    /* Высота на весь экран */
    width: 100vw;
    /* Ширина на весь экран */
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    /* Убираем прокрутку */
}

.background-image {
    position: absolute;
    /* Абсолютное позиционирование */
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    /* Пропорциональное сжатие */
    z-index: 1;
    /* Отправляем изображение на задний план */
}

.foreground-container {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
    width: 100%;
    /* Текст остается поверх */
    z-index: 1000;
    /* Устанавливаем текст выше изображения */
    color: #000;
    /* Цвет текста */
    font-size: 24px;
    gap: 48px;
}

.first-block {
    text-align: center;
    /* margin-left: 17.4479166667vw; */
    background-color: var(--color-white-1);
    padding: 20px 50px;
    border-radius: 10px;
}

.jameson-age-confirm {
    max-width: 100%;
    /* чтобы не выходила за контейнер */
    width: 100%;
    height: auto;
}

.title-text {
    margin-bottom: 0px;
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 30px;
    color: #865848;
    margin-top: 66px;
}

.date-input-container {
    display: flex;
    gap: 10px;
    /* Расстояние между полями */
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
}

.date-input {
    width: 115px;
    height: 55px;
    border: 2px solid #865848;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-md);
    color: #865848;
    outline: none;
}

.date-input::placeholder {
    color: var(--color-white);
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-md);
    opacity: 1;
}

.date-input:focus {
    border-color: red;
}

/* Убираем стрелочки */
.date-input::-webkit-inner-spin-button,
.date-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.date-input {
    -moz-appearance: textfield;
    /* Для Firefox */
}

.btn-confirm-mobile {
    max-width: 325px;
    width: 100%;
}

.btn-confirm,
.btn-confirm-mobile {

    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    color: var(--color-white-1);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-md);
    background: var(--color-primary-light);
    cursor: pointer;
    /* box-shadow: 0 4px 0 #04581d; */
    /* легкая тень для объёма */

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении */
.btn-confirm:hover,
.btn-confirm-mobile:hover {
    background: var(--color-primary-dark);
    /* лёгкое затемнение белого */
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #914b13;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-confirm:active,
.btn-confirm-mobile:active {
    background: var(--color-primary-dark);
    /* чуть темнее для нажатия */
    transform: translateY(2px);
    box-shadow: 0 2px 0 #9e9e9e;
    transition: all 0.1s ease-in;
}


/* ------------------------------------------------Mobile styles */
.second-block-mobile {
    text-align: center;
}

.overlay-mobile ::v-deep .v-overlay__content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

.main-container-mobile {
    background-image: url('../assets/img/ararat-reg-bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    min-height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 16px;
    box-sizing: border-box;
}

.foreground-container-mobile {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1000;
    color: #000;
    font-size: 24px;
    width: 100%;
    max-width: 365px;
    height: auto;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.first-block-mobile {
    text-align: center;
    padding: 30px 20px 25px 20px;
    background-color: var(--color-white-1);
    border-radius: 12px;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.jameson-logo-age-confirm-mobile {
    width: 200px;
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

.title-text-mobile {
    margin-top: 20px;
    margin-bottom: 0px;
    font-family: var(--font-family);
    color: #865848;
    font-size: 26px;
    line-height: 120%;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 400;
    overflow-y: hidden;
}

.title-text-mobile pre {
    margin-top: 0px;
    margin-bottom: 0px;
    font-family: inherit;
    color: #865848;
    font-size: 26px;
    line-height: 120%;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 400;
}

.date-input-container-mobile {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 24px;
    text-align: center;
    align-items: center;
    width: 100%;
}

.date-input-mobile {
    max-width: 325px;
    width: 100%;
    height: 52px;
    border: 2px solid #865848;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: #865848;
    outline: none;
    box-sizing: border-box;
}

.date-input-mobile::placeholder {
    color: #865848;
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-xs);
    opacity: 1;
}

.date-input-mobile:focus {
    border-color: red;
}

/* ------------------------------Styles для распихивание элементов по 4 углам */

.background-image-mobile-botright {
    position: absolute;
    bottom: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-botleft {
    position: absolute;
    bottom: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;

}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

/* .background-image-mobile {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 1;
} */

/*----------------------------------- Snackbar styles */
.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: var(--font-family);
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}

/* @media (orientation: landscape) {
    .foreground-container-mobile {
        height: auto;
    }
} */
</style>

<script>
import { mapActions } from "vuex";

export default {


    name: "ConfirmAge1",
    data() {
        return {
            isMobile: window.innerWidth < 1264,
            day: "",
            month: "",
            year: "",
            snackbar: false,
            message: "",
            visible: true,
        };
    },
    methods: {


        ...mapActions(['saveUserAge']),


        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        validateDay() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.day = this.day.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 31
            if (this.day > 31) {
                this.day = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный день (01-31).";
            }
        },
        validateMonth() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.month = this.month.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 12
            if (this.month > 12) {
                this.month = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный месяц (01-12).";
            }
        },
        validateYear() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 4 символов
            this.year = this.year.replace(/\D/g, "").slice(0, 4);
        },
        confirmRegistration() {
            let isValid = true;

            // Проверяем корректность дня
            if (this.day.length !== 2 || this.day > 31 || this.day < 1) {
                this.day = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный день (01-31).";
                isValid = false;
            }

            // Проверяем корректность месяца
            if (this.month.length !== 2 || this.month > 12 || this.month < 1) {
                this.month = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный месяц (01-12).";
                isValid = false;
            }

            // Проверяем корректность года
            if (this.year.length !== 4 || this.year < 1900 || this.year > new Date().getFullYear()) {
                this.year = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный год рождения.";
                isValid = false;
            }

            // Если есть некорректные поля, прекращаем выполнение
            if (!isValid) {
                return;
            }

            // Проверяем, что дата корректна
            const today = new Date();
            const birthDate = new Date(this.year, this.month - 1, this.day);

            if (
                birthDate.getDate() != this.day ||
                birthDate.getMonth() + 1 != this.month ||
                birthDate.getFullYear() != this.year
            ) {
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректную дату.";
                return;
            }

            // Проверяем возраст
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            const dayDiff = today.getDate() - birthDate.getDate();

            if (age > 21 || (age === 21 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))) {
                console.log(`Дата рождения: ${this.day}.${this.month}.${this.year}`);
                const userAge = `${this.year}-${this.month}-${this.day}`; // строка вида "дд.мм.гггг"


                // console.log("Итоговые данные:", userAge);
                // this.snackbar = true;

                // this.message = "Добро пожаловать!";
                this.saveUserAge(userAge);
                this.visible = false;
                document.body.style.overflow = "";
                document.body.style.height = "";// Сохраняем в Vuex
                // this.$router.push('/jameson'); // Переход на следующую страницу
            } else {
                this.snackbar = true;
                this.message = "Для дальнейшего входа нужно достичь 21 года.";
                return;
            }

            // Собираем данные в переменную userAge

        },


    },
    beforeDestroy() {
        document.body.style.overflow = ""
        document.body.style.height = ""
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        document.body.style.overflow = "hidden"
        document.body.style.height = "100vh"
        window.addEventListener('resize', this.handleResize);

    },
    computed: {
        // bgStyle() {
        //     return {
        //         backgroundImage: `url(${require('@/assets/img/age-confirmation-bg.png')})`,
        //         backgroundSize: 'contain',
        //         backgroundRepeat: 'no-repeat',
        //         backgroundPosition: 'center',
        //         width: '100vw', // Полная ширина экрана
        //         height: '100vh',
        //     };
        // }
    },

}

</script>